export default __webpack_public_path__ + "static/neu_current-2e5c595e2323e7c4cfcceee91508659b.svg";